import './styles.css';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RibbonsUtil from "../../utils/RibbonsUtil";
import InfiniteList from '../../components/InfiniteListNew';
import ButtonFilter from '../../components/ButtonFilter';
import RibbonGrid from '../../components/RibbonGridNew';
import {setMetricsEvent} from '../../actions/metrics';
import Utils, {
  setReloadMisContenidos, getReloadMisContenidos, showSoccerWorldCup,
  getNodeHeaderImage
} from '../../utils/Utils';
import asset from "../../requests/apa/Asset";
import Device from "../../devices/device";
import {getLinksFromNavConfiguration} from "../../components/Header";
import LayersControl from '../../utils/LayersControl';
import { MUNDIALSOCCERMATCHER, MUNDIALSOCCERTEAMS} from '../../components/RibbonNew/constants.js';
import {
  RibbonsObserver,
  LiveObserver,
  UpdateCardFromRibbonUserObserver,
  ADD_CARD,
  DELETE_CARD,
  UPDATE_CARD
} from '../../components/PersistentMiniEpg/MiniObserver'
import {
  showModal,
  MODAL_FILTER,
  MODAL_RECORD_SERIES_CONTENT
} from '../../actions/modal';

import LoadingIptvOttFlow from '../../AAF/LoaderExp/LoadingIptvOttFlow';
import Translator from "../../requests/apa/Translator";
import * as api from "../../requests/loader";
import store from '../../store';
import settings from '../../devices/all/settings';
import { playFullMedia } from '../../actions/playmedia';
import asyncPinObserver from '../../AAF/Pin/AsyncPinObserver';
import Spinner from '../../components/Spinner';
import AAFPlayer from 'src/AAFPlayer/AAFPlayer';
/*
import * as playerConstants from '../../utils/playerConstants';
import getAppConfig from '../../config/appConfig';
import { playPipMedia } from "../../actions/playmedia";

*/
import {removeDynamicFocus} from "../../components/Focus/utils";
import {
  CLASS_NAME_DEFAULT_FOCUSABLE_LIST_INFINITE
} from "../../components/Focus/constants";
import NewRelic from "../../utils/trackers/NewRelic";
import DeviceStorage from "../../components/DeviceStorage/DeviceStorage";
import {
  RENDER_FAILURE,
  sendLoadAppErrorToNewRelic,
  sendLoadAppToNewRelic
} from "../../utils/newRelic_loadApp/newRelic-load-app";
import {HOMEUSER} from "../../AAFPlayer/constants";
import Mundial2026 from '../Mundial2026/index.jsx';
import { getIsMundial2026 } from '../Mundial2026/utils.js';
import logger from 'src/utils/logger/logger';
import {
  isContinueWatchingRibbon,
  trackContinueWatchingEmpty,
  trackContinueWatchingLoadFailed,
  trackContinueWatchingLoadInitiated,
  trackContinueWatchingLoaded,
} from '../../services/datadog/continueWatching';

class Home extends Component {
  constructor(props) {
    super(props);
    this.keys = Device.getDevice().getKeys();
    this.userHash = this.props.user.session_userhash || '';
    let showRibbonWhenMount;
    if (LoadingIptvOttFlow.isToogleLevelsDelay()) {
      showRibbonWhenMount = typeof LoadingIptvOttFlow.isEnableRibbons() === 'boolean' ? LoadingIptvOttFlow.isEnableRibbons() : false;
    } else {
      showRibbonWhenMount = true;
    }
    this.state = {
      ribbons: [],
      user_status: 'anonymous',
      infiniteList: false,
      ribbonsTypeMenu: 'home',
      showRibbonWhenMount,
      buttonFilter: false,
      order: [],
      orderItems: [],
      prefixValidate: false,
      chargeList: false
    };
    this.ribbonsCategories = RibbonsUtil.getRibbonsCategories(props.code, props.nodes);
    this.groupId_focused = null;

    this.device = Device.getDevice().getPlatform();
    this.toggleFunctions = Utils.getToggleFunctionsFromMetadata();
    this.updateShowRibbonWhenMount = this.updateShowRibbonWhenMount.bind(this);
    this.onModalFilter = this.onModalFilter.bind(this);
    this.updateOrder = this.updateOrder.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.prefixCode = props.code;
    this.pbiInfo = this.pbiInfo.bind(this);
    this.setChargeList = this.setChargeList.bind(this);
  }

  getIsHomeUserNode(){
    return this.props.code === 'homeuser';
  };

  sendMetricsLoadErrorToNewRelic(){
    const isHomeUser = this.getIsHomeUserNode();
    isHomeUser && sendLoadAppErrorToNewRelic(RENDER_FAILURE)
  };

  sendMetricsLoadOkToNewRelic(){
    const isHomeUser = this.getIsHomeUserNode();
    isHomeUser && sendLoadAppToNewRelic(HOMEUSER)
  };

  shouldComponentUpdate(newProps, newState) {
    return (
      this.state.ribbons !== newState.ribbons ||
      this.state.ribbonsUser !== newState.ribbonsUser ||
      this.state.user_status !== newState.user_status ||
      this.state.infiniteList !== newState.infiniteList ||
      this.state.ribbonsTypeMenu !== newState.ribbonsTypeMenu ||
      this.state.showRibbonWhenMount !== newState.showRibbonWhenMount ||
      this.state.buttonFilter !== newState.buttonFilter ||
      this.state.order !== newState.order ||
      this.state.orderItems !== newState.orderItems ||
      this.state.prefixValidate !== newState.prefixValidate ||
      this.state.chargeList !== newState.chargeList ||
      this.state.forceUpdateMundial !== newState.forceUpdateMundial
    );
  }

  updateShowRibbonWhenMount(value) {
    const {showRibbonWhenMount} = this.state;
    if (showRibbonWhenMount !== value) {
      LoadingIptvOttFlow.setIsEnabled(true);
      this.setState({
          showRibbonWhenMount: true
        }, () => this.initRequests()
      );
    }
  }

  updateStatePlayerModalRecordings(){
    store.dispatch(playFullMedia({modalRecordSeriesContent: false}));
  }

  componentDidMount() {
    const {showRibbonWhenMount} = this.state;
    asyncPinObserver.subscribe(this.pbiInfo);
    RibbonsObserver.subscribe(this.updateShowRibbonWhenMount);
    UpdateCardFromRibbonUserObserver.subscribe(this.updateCardFromRibbonUser);
    if (showRibbonWhenMount) {
      this.initRequests();
    }
    Utils.addPageAction('home');

    this.addEventListeners();

  }

  pbiInfo(who){
    const element = document.getElementsByClassName('app-profile-none');
    if (who === 'awaitpbiInfo') {
      element[0].style['display']= 'block';
    }else if(who === 'pbiInfocomplete') {
      element[0].style['display']= 'none';
    }
  }

  componentWillUnmount() {
    removeDynamicFocus()
    asyncPinObserver.unsubscribe(this.pbiInfo);
    RibbonsObserver.unsubscribe(this.updateShowRibbonWhenMount);
    UpdateCardFromRibbonUserObserver.unsubscribe(this.updateCardFromRibbonUser);
    this.removeEventListeners()
  }


  async componentWillReceiveProps(nextProps) {
    const { modal = {}, player = {} } = store.getState().modal;
    const { modalType = null } = modal;
    const { modalRecordSeriesContent = false } = player;

    modalType === MODAL_FILTER && this.setState({infiniteList: false})

    //console.log("_____",this.getInfoMetric(this.props.user));
    logger.debug("[HOME] componentWillReceiveProps", nextProps.code)
      //  , nextProps
    this.setState({ prefixValidate: nextProps.code.includes('mundial') });


    const miscontenidosNode = Utils.getMisContenidosNode()

    if(modalRecordSeriesContent) {
      this.setState({ ribbons: [] })
      this.reloadMisContenidos(miscontenidosNode)
      setReloadMisContenidos(false)
      this.updateStatePlayerModalRecordings()

    }

    if (getReloadMisContenidos()) {
      if(nextProps.code === this.props.code && this.props.code === miscontenidosNode) {
        this.reloadMisContenidos(miscontenidosNode)
      }
      setReloadMisContenidos(false)
    }
    setReloadMisContenidos(false)

    const visibilityButtonFilter = this.props.code !== nextProps.code ? true : false;

    if (this.state.buttonFilter && visibilityButtonFilter) {
      switch(nextProps.code) {
        case nextProps.code:
          this.setState({ buttonFilter: false });
          break
        default:
          break
      }
    }

    if (this.props.code !== nextProps.code) {
      const node = nextProps.code || 'homeuser';
      const userStatus = this.resolveUserLogin();

      const isMundialNode = this.isMundialNode(nextProps);
      this.request(node, userStatus, this.props.updateFavoriteVOD, this.props.updateFavoriteChannels, isMundialNode);
      this.ribbonsCategories = RibbonsUtil.getRibbonsCategories(nextProps.code, nextProps.nodes);

      return true;
    }

    return false;
  }

  isMundialNode(nextProps) {
    let layout;
    if (!nextProps.appBehaviour) {
      layout = null;
    } else {
      layout = nextProps.appBehaviour.layout;
    }
    if(!Array.isArray(nextProps.nodes)) return false;
    const isChildMundial = this.isChildMundialNode(nextProps, nextProps.code);

    return isChildMundial;
  }

  isChildMundialNode(nextProps, currentCode) {
    let isMundial = false;
    if(!Array.isArray(nextProps.nodes)) return false;
    for(let i = 0; i < nextProps.nodes.length; i++) {
      let cnode = nextProps.nodes[i];
      if (cnode.app_behaviour && cnode.app_behaviour !== null) {
        const app_behaviour = JSON.parse(cnode.app_behaviour);
        if (app_behaviour && app_behaviour.layout && app_behaviour.layout === 'mundial') {
          if(cnode.childs && Array.isArray(cnode.childs)) {
            for(let j = 0; j < cnode.childs.length; j++) {
              let subnode = cnode.childs[j];
              if(subnode.code === currentCode) {
                isMundial = true;
                break;
              }
            }
          }
        }
      }
      if(isMundial) break;
    }

    return isMundial;
  }

  reloadMisContenidos(node){
    const userStatus = this.resolveUserLogin();
    this.request(node, userStatus);
  }

  handleKeyPress(e) {
    const { buttonFilter } = this.state;
    const pathname = window.location.pathname.split('/');
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;

    if (Utils.keyBloquedInPTV(pathname, currentKey)) {
      return;
    }

    const isplaying = LayersControl.isPlayerVisible();

    if (isplaying && currentKey === 'RED') return;

    if (!Utils.isModalHide()) {
      return;
    }

    const location = this.props.history.location.pathname.includes('node') && !this.props.history.location.pathname.includes('miscontenidos');

    switch (currentKey) {
      case 'RED':
        if (buttonFilter & location) {
          this.onModalFilter()
        }
        break;
      default:
        break;
    }
  }

  addEventListeners() {
    document.addEventListener('keydown', this.handleKeyPress, true);
    document.addEventListener(settings.button_filter, this.updateOrder, true);
  }

  removeEventListeners() {
    document.removeEventListener('keydown', this.handleKeyPress, true);
    document.removeEventListener(settings.button_filter, this.updateOrder, true);
  }



  initRequests = () => {
    const node = this.props.code || 'homeuser';
    const userStatus = this.resolveUserLogin();
    const showNode = this.onShowNode(this.props.appBehaviour);
    const nodeHome = this.getLinks().home;
    const isMundial = this.isMundialNode(this.props)

    if (showNode) {
      this.request(node, userStatus, this.props.updateFavoriteVOD, this.props.updateFavoriteChannels, isMundial);
    } else {
      this.request(nodeHome, userStatus, this.props.updateFavoriteVOD, this.props.updateFavoriteChannels);
    }
  }

  forceUpdateGrid = () => {
    this.initRequests();
  }

  onShowNode(app_behaviour) {
    const { user: { isLoggedIn } = {} } = this.props;
    if (app_behaviour){
      const {node_config: {vis : {anon = 1, loggedin = 1} = {}} = {}} = app_behaviour || {};
      return isLoggedIn ? loggedin === 1:  anon === 1;;
    } else {
      return true
    }
  }

  getLinks() {
    return getLinksFromNavConfiguration();
  }

  resolveUserLogin() {
    let userType = 'anonymous';
    if (this.props.user.isLoggedIn && this.props.user.superhighlight) {
      userType = this.props.user.superhighlight.join();
    }
    return userType;
  }

  getShowCarruselSoccerWorldCup(resp){
    const showSoccerWorldCupKey = showSoccerWorldCup();
    if(showSoccerWorldCupKey.enable){
      return resp;
    }else{
       resp.components = resp.components = resp.components.filter(ribbon => (ribbon.type !== MUNDIALSOCCERMATCHER && ribbon.type !== MUNDIALSOCCERTEAMS))
      return resp;
    }
  }

  async request(node, userStatus, callBackVOD, callBackChannels, isMundial){
    // Caso mundial: solo actualizar flag y salir
    if (isMundial) {
      this.setState({ ribbons: [], forceUpdateMundial: node });
      return;
    }

    // Limpiar ribbons actuales en un solo setState inicial
    this.setState({ infiniteList: false, ribbons: [] });

    // Cargar canales lineales antes de los ribbons
    const loadLinealChannels = this.props.loadLinealChannels;
    if (loadLinealChannels && typeof loadLinealChannels === 'function') {
      await loadLinealChannels();
    }

    const rb = new RibbonsUtil();

    rb.getMiddlewareRibbons(node, userStatus, (resp) => {
      resp = this.getShowCarruselSoccerWorldCup(resp);
      const ribbons = resp.components;
      const infiniteList = resp.gridType !== 'ribbons';

      // Acumular estado de filtros para aplicar en un solo setState
      let filterState = {};
      logger.info('[HOME] entre', resp);
      resp.components.forEach(items => {
        if (items.ordenamiento) {
          filterState = { buttonFilter: true, orderItems: items.ordenamiento };
        }
      });

      // Determinar si hay datos de usuario

      ribbons.length > 0 ? this.sendMetricsLoadOkToNewRelic() : this.sendMetricsLoadErrorToNewRelic();

      const usrStore = store.getState();
      const userhash = usrStore.user.session_userhash;
      const usertoken = usrStore.user.user_token;
      const hasUserData = resp.byUser && (this.userHash || userhash || usertoken);

      if (hasUserData) {
        const token = this.props.user && this.props.user.user_token
          ? this.props.user.user_token
          : null;

         trackContinueWatchingLoadInitiated({ node, userStatus, hasUserToken: Boolean(token) });

        rb.getUserMiddlewareRibbons(node, userStatus, (userResp) => {
          const ribbonsUser = userResp.components;
          //Datos de data dog trackContinueWatchingLoaded y trackContinueWatchingEmpty
          const continueWatchingRibbon = Array.isArray(ribbonsUser)
            ? ribbonsUser.find(isContinueWatchingRibbon)
            : null;
          const totalComponents = Array.isArray(ribbonsUser) ? ribbonsUser.length : 0;
          trackContinueWatchingLoaded({ node, userStatus, ribbon: continueWatchingRibbon, totalComponents });
          if (!continueWatchingRibbon || !Array.isArray(continueWatchingRibbon.items) || continueWatchingRibbon.items.length === 0) {
            trackContinueWatchingEmpty({ node, userStatus, ribbon: continueWatchingRibbon, totalComponents });
          }
          // Fin de la sección de tracking de DataDog para continue watching
          const ribbons_show_delete_button = Utils.getRegionaliazedMetadata(
            'ribbons_show_delete_button',
            '{"default":{"lastseen":{"enable":true,"type":["Actividad-reciente","actividadreciente","Continua-viendo","continuaviendo", "Recien-visto"]},"favorite":{"enable":true,"type":["Por-ver","porver","porver-live","porver-vod"]}}}'
          );

          if (ribbonsUser) {
            ribbonsUser.forEach((it) => {
              // Traducir títulos de recomendaciones
              if (it.title) {
                it.title = it.title
                  .replace('home_user_recome2one_one_title', Translator.get('home_user_recome2one_one_title', 'Sugerencias para ti'))
                  .replace('home_user_recome2one_first_title', Translator.get('home_user_recome2one_first_title', 'Porque viste'))
                  .replace('home_user_recome2one_second_title', Translator.get('home_user_recome2one_second_title', 'te recomendamos'));
              }
              it.showFooter = Object
                .values(ribbons_show_delete_button)
                .some(activity => activity.enable && activity.type.includes(it.id));
            });
          }

          // Un solo setState con todos los datos listos (ribbons + usuario + filtros)
          this.setState({
            ribbons,
            ribbonsUser,
            infiniteList: false,
            ...filterState,
          }, () => this.callBackFire());

        }, token, () => {
          trackContinueWatchingLoadFailed({
            node,
            userStatus,
            error: { message: 'user_ribbons_request_failed' },
          });
          // Error al cargar ribbons de usuario: mostrar solo ribbons base
          this.setState({
            ribbons,
            infiniteList,
            ...filterState,
          }, () => this.callBackFire());
        });
      } else {
        // Sin datos de usuario: un solo setState con todo
        this.setState({
          ribbons,
          ribbonsUser: null,
          infiniteList,
          ...filterState,
        }, () => this.callBackFire());
      }

      // Ocultar spinner de carga
      const element = document.getElementsByClassName('app-profile-none');
      if (element[0]) element[0].style.display = 'none';
      logger.info('[HOME] getMiddlewareRibbons after setState');
    }, null, () => {
      // Error al cargar ribbons: solo disparar callback
      this.callBackFire();
    });
  }

  callBackFire = () => {
    if (!LoadingIptvOttFlow.isLoadLive()) {
      LiveObserver.fire();
    }
  }

  onModalFilter () {
    const { orderItems } = this.state;
    const modal = {
      modalType: MODAL_FILTER,
      modalProps: {
        orderItems: orderItems,
        setChargeList: this.setChargeList
      }
    };
    this.setChargeList(true)
    store.dispatch(showModal(modal));
  }

  setChargeList(value) {
    this.setState({ chargeList: value });
  }

  updateCardFromRibbonUser = ({ action = "", ribbonIds = [], cardGroupId = null, card = null }) => {
    const { ribbonsUser  = [] } = this.state;
      const newRibbonsUser = ribbonsUser.map( _ribbon => {
        const ribbon = {..._ribbon};
        if( Array.isArray(ribbonIds) && ribbon.id && ribbonIds.includes(ribbon.id) && Array.isArray(ribbon.items)) {
          if(action === ADD_CARD && card){
            ribbon.items.unshift(card);
          }
          else if( action === DELETE_CARD){
            ribbon.items = ribbon.items.filter(it => {
              if(it.isRecord){
                return it.event_id !== cardGroupId;
              }else{
                if(it.isSeries && it.ext_series_id){
                  return it.ext_series_id !== cardGroupId;
                }else{
                  return it.group_id !== cardGroupId;
                }
              }
            });
          }else if(action === UPDATE_CARD){
            ribbon.items = ribbon.items.filter(it => {
              if(it.isSeries && it.ext_series_id && it.ext_series_id === cardGroupId && it.numEpisodes &&  card.numEpisodesNew){
                  it.numEpisodes = card.numEpisodesNew;
                  const element = document.getElementById(`serie_${cardGroupId}`);
                  if(element && element.innerText){
                    element.innerText = Utils.numberEpisodesCardRecordings(card.numEpisodesNew);
                  }
              }
              return it;
            });
          }
        }
        return ribbon;
      });

      this.setState({
        ribbonsUser: newRibbonsUser
      });
  }

  updateOrder (order) {
    this.setState({ order: order.detail})
  }

  getCode  () {
    if (typeof window === 'undefined' || !window.location) {
      return { currentUrl: '', lastPathSection: '' };
    }

    const { href, pathname } = window.location;
    const normalizedPath = pathname.replace(/\/+$/, '');
    const pathSegments = normalizedPath.split('/').filter(Boolean);
    const lastSegment = pathSegments.length ? pathSegments[pathSegments.length - 1] : '';


    return decodeURIComponent(lastSegment)
  };

  render() {
    const {
      showRibbonWhenMount,
      buttonFilter,
      order,
      prefixValidate
    } = this.state;
    setReloadMisContenidos(false)
    const { code, nodes } = this.props;
    logger.info('[Home] render ',
      '\nthis.props.code', this.props.code,
      '\nthis.props.user', this.props.user
    );
    const userStatus = this.resolveUserLogin();
    if(code.includes('mundial')) {
      nodes.forEach((n) => {
        if (n.childs && n.childs.find(c => c.code === code)) {
          this.prefixCode = n.code;
        } else if (n.code === code) {
          this.prefixCode = n.code;
        }
      });
    }

    const isMundial2026 = getIsMundial2026(this.props.code);

    return (
      showRibbonWhenMount ?
        <div className="home-container">
          { this.state.infiniteList && <div>
            {
              getNodeHeaderImage(this.getCode(), DeviceStorage.getItem('region')) && !isMundial2026 && <div style={{ width: '100%' }} className={'HeadBrandContainer'}>
                <img src={getNodeHeaderImage(this.getCode(), DeviceStorage.getItem('region'))} alt="" style={{ width: '100%' }}/>
              </div>
            }
          </div> }
          {buttonFilter && <div className={'horizontal-bar'}></div>}
          {buttonFilter && !Utils.getHasClaroMusicaNode() && <ButtonFilter
            navigation = {{
              up: '#aaf_menu-container-center .active.focusable',
              down: "#secondlevel_link_1",
            }}
            onModalFilter={this.onModalFilter}
          />
          }

          { /* Si el nodo es Mundial 2026 muestra la experiencia */ }
          { isMundial2026 && <Mundial2026 /> }

          {!this.state.infiniteList && <RibbonGrid
            // El middleware manda al ribbon los titulos incorrectamente para noggin.
            ribbonsTypeMenu={this.state.ribbonsTypeMenu}
            ribbonsPrev={this.state.ribbons}
            ribbonsUser={this.state.ribbonsUser}
            ribbonsCategories={ isMundial2026 ? null : this.ribbonsCategories}
            user={this.props.user}
            asset={asset}
            setMetricsEvent={this.props.setMetricsEvent}
            forceUpdateGrid={this.forceUpdateGrid}
            code={this.props.code}
            history={this.props.history}
          />}
          {this.state.infiniteList && <InfiniteList
            setChargeList={this.state.chargeList}
            order={order}
            user={this.props.user}
            level={this.props.code}
            setMetricsEvent={this.props.setMetricsEvent}
            ribbonsCategories={isMundial2026 ? null : this.ribbonsCategories}
            buttonFilter={Utils.getHasClaroMusicaNode() && !isMundial2026 && buttonFilter}>
            <ButtonFilter
              navigation = {{
                up: '#aaf_menu-container-center .active.focusable',
                down: '.selected',
              }}
              onModalFilter={this.onModalFilter}
            />
            </InfiniteList>}
        </div> : null
    )
  }
}

const mapStateToProps = state => ({user: state.user, player: state.player});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setMetricsEvent,
  showModal,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/index.jsx